module.exports = __webpack_public_path__ + "static/media/ncaa-logo.8c9f8a0f.svg";